module.exports = __webpack_public_path__ + "img/ac480f8147fd44b8bdf3ef256e527174.36203601.jpg";